import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { environment } from "../environments/environment";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { HIGHLIGHT_OPTIONS, HighlightModule, HighlightOptions } from "ngx-highlightjs";
import { TestComponentComponent } from "./test-component/test-component.component";
import { ObservableRequestComponent } from "./components/observable-request/observable-request.component";
import { PromiseRequestComponent } from "./components/promise-request/promise-request.component";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DndDirective } from "./directives/dnd.directive";

import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { MatInputModule } from "@angular/material/input";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatBadge, MatBadgeModule } from "@angular/material/badge";

///////////////////////////////////////////////////////////////
// libComm
import {ActionBarComponent} from "libComm";
import {GetValueOnConditionPipe} from "libComm";
import {CustomBtnComponent} from "libComm";
import {DialogComponent} from "libComm";
import {SaveConfirmComponent} from "libComm";
import {AppInfoComponent} from "libComm";
import {TopbarComponent} from "libComm";
import {CustomSelectComponent} from "libComm";
import {MenuListItemComponent} from "libComm";
import {MenuSideBarComponent} from "libComm";
import {TooltipSelectComponentsPipe} from "libComm";
import {TranslateOptionWithPrefixPipe} from "libComm";

// import {FilterSettingsComponent} from "libComm";
// import {FilterPanelComponent} from "libComm";
//
import {NavService} from "libComm";
import {CoreService} from "libComm";
import {LibCommService} from "libComm";

// for libComm integration
import {EURTranslatorLoaderService} from "./_lib_integration/services/EURTranslatorLoader.service";
import {EURAuthorizeService} from "./_lib_integration/services/EURAuthorize.service";
import {EURAppInfoService} from "./_lib_integration/services/EURAppInfo.service";
import {EURIdentityService} from "./_lib_integration/services/EURIdentity.service";
import {EURTranslatorManager} from "./_lib_integration/models/EURTranslatorManager.model";
import {EURMenuService} from "./_lib_integration/services/EURMenu.service";



import
{
	MSAL_GUARD_CONFIG,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG,
	MsalBroadcastService,
	MsalGuard,
	MsalGuardConfiguration,
	MsalInterceptor,
	MsalInterceptorConfiguration,
	MsalModule,
	MsalRedirectComponent,
	MsalService,
} from "@azure/msal-angular";
import
{
	BrowserCacheLocation,
	InteractionType,
	IPublicClientApplication,
	LogLevel,
	PublicClientApplication,
} from "@azure/msal-browser";

import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from "@angular/common/http";
// import { TopbarComponent } from "./components/shared/topbar/topbar.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthService } from "./services/auth.service";
import { NotFoundComponent } from "./components/pages/not-found/not-found.component";
import { DynamicPageComponent } from "./components/pages/dynamic-page/dynamic-page.component";
// import { MenuListItemComponent } from "./components/shared/menu-list-item/menu-list-item.component";
import { AuthInterceptorService } from "./services/auth.interceptor.service";
import { HomeComponent } from "./components/pages/home/home.component";
// import { NavService } from "./services/nav.service";
// import { CustomBtnComponent } from "./components/shared/custom-btn/custom-btn.component";
import { DataTableComponent } from "./components/shared/data-table/data-table.component";
import { CustomTextFieldComponent } from "./components/shared/custom-text-field/custom-text-field.component";
// import { ActionBarComponent } from "./components/shared/action-bar/action-bar.component";
import { AlertComponent } from "./components/shared/alert/alert.component";
import { LoadingComponent } from "./components/shared/loading/loading.component";
import { EmailPreviewComponent } from "./components/shared/email-preview/email-preview.component";
import { VirtualScrollComponent } from "./components/shared/virtual-scroll/virtual-scroll.component";
import { UserSettingsComponent } from "./components/shared/user-settings/user-settings.component";
import { CheckboxFilterComponent } from "./components/shared/checkbox-filter/checkbox-filter.component";
import { BlankComponent } from "./components/shared/blank/blank.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { CustomCheckboxComponent } from "./components/shared/custom-checkbox/custom-checkbox.component";
import { CustomFilterComponent } from "./components/shared/filter/custom-filter/custom-filter.component";
import { MatSelectModule } from "@angular/material/select";
import { CustomDatepickerComponent } from "./components/shared/custom-datepicker/custom-datepicker.component";
// import { CustomSelectComponent } from "./components/shared/custom-select/custom-select.component";
//import { CustomMultiselectComponent } from './components/shared/custom-multiselect/custom-multiselect.component';
import { CustomMultiselectModule } from "./components/shared/custom-multiselect/custom-multiselect.module";
import { FilterPanelComponent } from "./components/shared/filter/filter-panel/filter-panel.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatExpansionModule } from "@angular/material/expansion";
import { FilterSettingsComponent } from "./components/shared/filter/filter-settings/filter-settings.component";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import
{
	CustomTablePaginatorComponent
} from "./components/shared/custom-table-paginator/custom-table-paginator.component";
import { RefactorNamePipe } from "./pipes/refactor-name.pipe";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CustomAutocompleteComponent } from "./components/shared/custom-autocomplete/custom-autocomplete.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { GeneralComponent } from "./components/shared/template/general/general.component";
import { DndComponent } from "./components/shared/dnd/dnd.component";
// import { DialogComponent } from "./components/shared/dialog/dialog.component";
import { HaveActionPipe } from "./pipes/have-action.pipe";
import { CustomSelectValuesComponent } from "./components/shared/custom-select-values/custom-select-values.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { DocumentsComponent } from "./components/pages/documents/documents.component";
import { BackNavigationDirective } from "./directives/utils/back-navigation.directive";
import { GetListTooltipPipe } from "./pipes/get-list-tooltip.pipe";
// import { GetValueOnConditionPipe } from "./pipes/get-value-on-condition.pipe";
import { CompareEditingPipe } from "./pipes/compare-editing.pipe";
import { HttpLoggerInterceptor } from "./services/logger.http.interceptor.service";
// import { AppInfoComponent } from "./components/shared/dialog/app-info/app-info.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { GetOptionsPipe } from "./pipes/get-options.pipe";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { GeneralService } from "./services/crud/general.service";
import { LanguageComponent } from "./components/shared/template/language/language.component";
import { Camel2SnakePipe } from "./pipes/camel2snake.pipe";
import { AddLanguageComponent } from "./components/shared/template/language/add-language/add-language.component";
import { RemoveDoubleQuotePipe } from "./pipes/removeDoubleQuote.pipe";
import { RemoveDoubleQuoteAndSlachPipe } from "./pipes/removeDoubleQuoteAndSlash.pipe";
import { AddTranslationComponent } from "./components/shared/template/language/add-translation/add-translation.component";
import { HaveOneActionPipe } from "./pipes/have-one-action.pipe";
import { GetValueOnConditionImpurePipe } from "./pipes/get-value-on-condition-impure.pipe";
import { StringArrayTranslationPipe } from "./pipes/string-array-translation.pipe";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CheckForUpdateService } from "./services/check-for-update.service";
import { CdkHeightCalculatorPipe } from "./pipes/cdk-height-calculator.pipe";
import { BadRequestComponent } from "./components/pages/bad-request/bad-request.component";
import { CustomIconBtnComponent } from "./components/shared/custom-icon-btn/custom-icon-btn.component";
import { HttpSpinnerInterceptorService } from "./services/http-spinner.interceptor.service";
import { FunctionsComponent } from "./components/pages/functions/functions.component";
import { GetListTooltipV2Pipe } from "./pipes/get-list-tooltip-v2.pipe";
import { GetListTooltipV2ClassicPipe } from "./pipes/get-list-tooltip-v2-classic.pipe";
import { ngxLoadingAnimationTypes, NgxLoadingModule } from "ngx-loading";
import { TitleCasePipe } from "@angular/common";
import { DialogDownloadComponent } from './components/shared/dialog-download/dialog-download.component';
// import { SaveConfirmComponent } from "./components/shared/dialog/save-confirm/save-confirm.component";
import { SafeUrlPipe } from "./pipes/safe-url.pipe";
import { SortArrayPipe } from "./pipes/sort-array.pipe";
import { FrameworkTypeDirective } from "./directives/utils/framework-type.directive";
import { MultiSelectComponent } from './components/shared/multi-select/multi-select.component';
import { TranslationService } from "./services/translation-service";
import { ChoosePlantDialogComponent } from './components/shared/choose-plant-dialog/choose-plant-dialog.component';
import { MessageDialogComponent } from './components/shared/message-dialog/message-dialog.component';
import { DataTableSettingsComponent } from './components/shared/data-table-settings/data-table-settings.component';


const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export function loggerCallback(logLevel: LogLevel, message: string)
{
}

export function MSALInstanceFactory(): IPublicClientApplication
{
	return new PublicClientApplication({
		auth: {
			clientId: environment.clientId,
			authority: environment.stsAuthority,
			redirectUri: `${window.location.origin}/eur`,
			postLogoutRedirectUri: `${window.location.origin}/eur`,
		},
		cache: {
			cacheLocation: BrowserCacheLocation.LocalStorage,
			storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
		},
		system: {
			loggerOptions: {
				loggerCallback,
				logLevel: LogLevel.Error,
				piiLoggingEnabled: false,
			},
			iframeHashTimeout: 9000,
		},
	});
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration
{
	const protectedResourceMap = new Map<string, Array<string>>();

	return {
		interactionType: InteractionType.Redirect,
		protectedResourceMap,
	};
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration
{
	return {
		interactionType: InteractionType.Redirect,
		authRequest: {
			scopes: environment.clientScope.toLowerCase().split(" "),
		},
		loginFailedRoute: "/",
	};
}

/* LZ
export function httpTranslateLoader(http: HttpClient, translationService: TranslationService)
{
	return new TranslationLoader(http, translationService);
}

export class TranslationLoader implements TranslateLoader
{
	constructor(private http: HttpClient, private translationService: TranslationService)
	{
	}

	getTranslation(lang: string): Observable<any>
	{
		return new Observable<any>((observer) =>
		{
			this.translationService.getLanguage(lang).subscribe(res =>
			{
				observer.next(res);
				observer.complete();
			})
		})

		return ;
	}
} */

@NgModule({
	declarations: [
		AppComponent,
		TestComponentComponent,
		ObservableRequestComponent,
		PromiseRequestComponent,
		DndDirective,
		TopbarComponent,
		NotFoundComponent,
		DynamicPageComponent,
		MenuListItemComponent,
		HomeComponent,
		DataTableComponent,
		CustomBtnComponent,
		CustomTextFieldComponent,
		ActionBarComponent,
		AlertComponent,
		LoadingComponent,
		EmailPreviewComponent,
		VirtualScrollComponent,
		UserSettingsComponent,
		CheckboxFilterComponent,
		BlankComponent,
		CustomCheckboxComponent,
		CustomFilterComponent,
		CustomDatepickerComponent,
		CustomSelectComponent,
		FilterPanelComponent,
		FilterSettingsComponent,
		CustomTablePaginatorComponent,
		RefactorNamePipe,
		CustomAutocompleteComponent,
		GeneralComponent,
		DndComponent,
		DialogComponent,
		HaveActionPipe,
		CustomSelectValuesComponent,
		DocumentsComponent,
		BackNavigationDirective,
		GetListTooltipPipe,
		GetValueOnConditionPipe,
		CompareEditingPipe,
		AppInfoComponent,
		GetOptionsPipe,
		LanguageComponent,
		Camel2SnakePipe,
		AddLanguageComponent,
		RemoveDoubleQuotePipe,
		RemoveDoubleQuoteAndSlachPipe,
		AddTranslationComponent,
		HaveOneActionPipe,
		GetValueOnConditionImpurePipe,
		StringArrayTranslationPipe,
		CdkHeightCalculatorPipe,
		BadRequestComponent,
		CustomIconBtnComponent,
		FunctionsComponent,
		GetListTooltipV2Pipe,
		GetListTooltipV2ClassicPipe,
		DialogDownloadComponent,
		GeneralComponent,
		SaveConfirmComponent,
		SafeUrlPipe,
		SortArrayPipe,
		FrameworkTypeDirective,
		MultiSelectComponent,
		ChoosePlantDialogComponent,

		TranslateOptionWithPrefixPipe,
		TooltipSelectComponentsPipe,
		MenuSideBarComponent,
		MessageDialogComponent,
  DataTableSettingsComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		NgbModule,
		MatMenuModule,
		MatIconModule,
		MatToolbarModule,
		MatButtonModule,
		MatSidenavModule,
		MatListModule,
		MatInputModule,
		MatCheckboxModule,
		MatAutocompleteModule,
		MatTooltipModule,
		MatBadgeModule,
		HighlightModule,
		FormsModule,
		ReactiveFormsModule,
		HttpClientModule,
		MsalModule,
		BrowserAnimationsModule,
		MatProgressSpinnerModule,
		NgxLoadingModule.forRoot({
			animationType: ngxLoadingAnimationTypes.cubeGrid,
			backdropBackgroundColour: "rgba(0,0,0,0.9)",
			fullScreenBackdrop: true,
			primaryColour: "#ffffff",
			secondaryColour: "#ffffff",
			tertiaryColour: "#ffffff",
		}),
		MatSelectModule,
		CustomMultiselectModule,
		DragDropModule,
		MatExpansionModule,
		MatDialogModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatSlideToggleModule,
		ScrollingModule,
		///////////////////////////////////////////////////////
		//TranslateModule.forRoot({
		//	loader: {
		//		provide: TranslateLoader,
		//		useFactory: httpTranslateLoader,
		//		deps: [HttpClient, TranslationService]
		//	}
		//}),		
		// LZ for libComm
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useClass: EURTranslatorLoaderService, // custom translation loader
				// useFactory: EURTranslatorLoader,
				// useFactory: httpTranslateLoader,
				// deps: [HttpClient, GeneralService]
				deps: [HttpClient, TranslationService]
			}
		}),		
	],
	providers: [
		/////////////////////////////////////////////////////////////////////////////
		// libComm integration
		NavService,
		CoreService,
		LibCommService,
		{provide: 'ITranslatorManager', useClass : EURTranslatorManager},
		{provide: 'IAuthorizeService', useClass: EURAuthorizeService},
		{provide: 'IIdentityService', useClass: EURIdentityService},
		{provide: 'IAppInfoService', useClass: EURAppInfoService},
		{provide: 'IMenuService', useClass: EURMenuService},
		/////////////////////////////////////////////////////////////////////////////		
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MsalInterceptor,
			multi: true,
		},
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory,
		},
		{
			provide: MSAL_GUARD_CONFIG,
			useFactory: MSALGuardConfigFactory,
		},
		{
			provide: MSAL_INTERCEPTOR_CONFIG,
			useFactory: MSALInterceptorConfigFactory,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptorService,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpLoggerInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpSpinnerInterceptorService,
			multi: true,
		},
		MsalService,
		MsalGuard,
		MsalBroadcastService,
		AuthService,
		{
			provide: HIGHLIGHT_OPTIONS,
			useValue: <HighlightOptions>{
				lineNumbers: true,
				coreLibraryLoader: () => import("highlight.js/lib/core"),
				lineNumbersLoader: () => import("highlightjs-line-numbers.js"),
				themePath: "node_modules/highlight.js/styles/github.css",
				languages: {
					typescript: () => import("highlight.js/lib/languages/typescript"),
					css: () => import("highlight.js/lib/languages/scss"),
					xml: () => import("highlight.js/lib/languages/xml"),
				},
			},
		},
		{ provide: MAT_DIALOG_DATA, useValue: {} },
		{ provide: MatDialogRef, useValue: {} },
		NavService,
		CheckForUpdateService,
		GetListTooltipV2Pipe,
		Camel2SnakePipe,
		GetListTooltipV2ClassicPipe,
		TitleCasePipe
	],
	bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule
{
}
